module.exports = "<p>\r\n\t<b>Orders:</b> - Coming soon in the following update.\r\n</p>\r\n"